var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page-section', {
    staticClass: "page-section--last page-section--sm",
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("기술력으로 증명하는 "), _c('span', {
          staticClass: "primary--text"
        }, [_vm._v("유산균 전문기업")])];
      },
      proxy: true
    }, {
      key: "txt",
      fn: function () {
        return [_c('span', {
          staticClass: "grey--text text--darken-4"
        }, [_vm._v(" (주)웰빙엘에스는 국내 최고 수준의 식물성유산균 기술력을 바탕으로 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v(" 다양한 프로바이오틱스 및 포스트바이오틱스 제품과 발효제품을 개발하고 있습니다. ")])];
      },
      proxy: true
    }])
  }, [_c('v-sheet', {
    staticClass: "company-content"
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "10"
    }
  }, [_c('v-row', {
    staticClass: "row--xxl mb-0",
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('v-col', {
      key: item.name,
      staticClass: "company-item",
      attrs: {
        "cols": "6",
        "lg": "3"
      }
    }, [_c('v-card', [_c('div', [_c('v-img', {
      staticClass: "mx-auto",
      attrs: {
        "src": item.icon,
        "alt": "",
        "max-width": "40"
      }
    }), _c('div', {
      staticClass: "txt txt--lg txt--dark font-weight-bold mt-4"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1)]), _c('p', {
      staticClass: "text-center txt txt--lg txt--dark font-weight-bold",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('v-sheet', {
    staticClass: "company-content"
  }, [_c('div', {
    staticClass: "tit-wrap--lg text-center"
  }, [_c('h3', {
    staticClass: "tit tit--sm font-weight-medium"
  }, [_vm._v("주요 특허 등록")])]), _c('v-sheet', {
    staticClass: "patent-wrap",
    attrs: {
      "color": "grey lighten-5",
      "rounded": "xl"
    }
  }, [_c('v-row', {
    staticClass: "row--lg",
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.patents, function (patent) {
    return _c('v-col', {
      key: patent.number,
      attrs: {
        "cols": "6",
        "lg": "4",
        "xl": ""
      }
    }, [_c('div', {
      staticClass: "txt txt--sm txt--dark d-flex justify-center align-center"
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "color": "primary",
        "small": ""
      }
    }, [_vm._v("mdi-checkbox-marked-outline")]), _c('span', {
      staticClass: "font-weight-medium"
    }, [_vm._v(_vm._s(patent.number))])], 1), _c('v-img', {
      staticClass: "mx-auto my-10px",
      attrs: {
        "src": patent.image,
        "alt": "",
        "max-width": "170"
      }
    }), _c('div', {
      staticClass: "txt txt--lg txt--dark font-weight-bold text-center",
      domProps: {
        "innerHTML": _vm._s(patent.name)
      }
    })], 1);
  }), 1)], 1), _c('div', {
    staticClass: "d-flex justify-center align-start text-center mt-6 mt-md-10"
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/icon-quote-open.svg",
      "alt": "",
      "width": "18"
    }
  }), _c('div', {
    staticClass: "tit tit--xs mx-1"
  }, [_vm._v("그 외 총 "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("26건 특허, 12건 디자인, 55건 상표")]), _vm._v(" 보유")]), _c('img', {
    attrs: {
      "src": "/images/icon/icon-quote-close.svg",
      "alt": "",
      "width": "18"
    }
  })]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  })], 1)], 1), _c('v-sheet', {
    staticClass: "company-content"
  }, [_c('marks-list')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }